import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-buyers-set-block-by-admin-dialog',
  templateUrl: './buyers-set-block-by-admin-dialog.component.html',
  styleUrls: ['./buyers-set-block-by-admin-dialog.component.scss'],
})
export class BuyersSetBlockByAdminDialogComponent {
  buyer?: Buyer;
  is_set_block_running: boolean = false;
  first_toggle_status: boolean;
  is_toggle_changed: boolean = false;
  is_toggle_checked: boolean;
  is_toggle_to_block: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<BuyersSetBlockByAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private error_service: ErrorService,
    private buyers_service: BuyersService,
  ) {
    this.buyer = data.buyer;
    this.is_toggle_checked = this.buyer?.blocked_by_admin || false;
    this.first_toggle_status = this.is_toggle_checked;
  }

  onToggleChange(): void {
    this.is_toggle_checked = !this.is_toggle_checked;
    this.is_toggle_changed = this.is_toggle_checked !== this.first_toggle_status;
  }

  onConfirmClick(): void {
    if (this.is_toggle_changed) {
      this.is_set_block_running = true;
      this.buyers_service.setBlockByAdmin(this.buyer?.buyer_id || '', this.is_toggle_checked).subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_set_block_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_set_block_running = false;
        },
      });
    } else {
      console.warn('No changes made to the block status.');
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }
}
